import { render, staticRenderFns } from "./Dash-audience.vue?vue&type=template&id=4931ab5c"
import script from "./Dash-audience.vue?vue&type=script&lang=js"
export * from "./Dash-audience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports